module.exports = __webpack_public_path__ + "static/media/undraw_logic_n6th.cfb386bf.svg";